/*
 * @Author: Zhouqi
 * @Date: 2025-11-03 14:08:30
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-08 11:51:13
 */
import Image from 'next/image';
import { useRouter } from 'next/router';
import { memo, useMemo } from 'react';

import { useRouteChange } from '@/hooks/useRouteChange';
import { useTranslate } from '@/hooks/useTranslate';
import { ROUTE_FROM } from '@/utils/const';
import { EventNewID, PageVisitFrom } from '@/utils/eventlog/eventNewConfig';
import { trackEvent } from '@/utils/eventlog/logAdapter';
import {
  aiRemovalURL,
  aiVideoEditURL,
  faceSwapperURL,
  productAvatarURL,
  VoiceCloneTabParam,
  voiceCloneURL,
} from '@/utils/router';

import styles from './index.module.scss';

const PopularTool = memo(() => {
  const { t } = useTranslate();
  const { navigate } = useRouteChange();
  const router = useRouter();
  const tools = useMemo(
    () => [
      {
        pic: (
          <Image
            width={276}
            height={122}
            src={'/images/3.0-faceSwap.png'}
            className="w-full h-full"
            alt={t('2-0')}
            priority
          />
        ),
        title: t('2-0'),
        description: t('707ba0d101de744d11b5853788aedcdc'),
        navigateURL: faceSwapperURL,
      },
      // {
      //   pic: (
      //     <Image src={videText} className="w-full h-full" alt={t('Subtitle-Remove')} />
      //   ),
      //   title: t('Subtitle-Remove'),
      //   description: t('7b3381742b545d194e4b204cc40b6846'),
      // },
      {
        pic: (
          <Image
            width={276}
            height={122}
            src={'/images/3.0-voiceClone.png'}
            className="w-full h-full"
            alt={t('ce24a821ce9a84f071a4b291570d64b6')}
            priority
          />
        ),
        title: t('ce24a821ce9a84f071a4b291570d64b6'),
        description: t('e645136f01f6eeb384f132b55f701a5a'),
        navigateURL: voiceCloneURL + `?tab=${VoiceCloneTabParam.VOICE_CLONE}`,
      },
      // {
      //   pic: (
      //     <Image
      //       src={imageTranslate}
      //       className="w-full h-full"
      //       alt={t('bc.ImageTranslation')}
      //     />
      //   ),
      //   title: t('bc.ImageTranslation'),
      //   description: t('707ba0d101de744d11b5853788aedcdc'),
      // },
      {
        pic: (
          <Image
            width={276}
            height={122}
            src={'/images/3.0-productAvatar.png'}
            className="w-full h-full"
            alt={t('Product-avatar-video')}
            priority
          />
        ),
        title: t('Product-avatar-video'),
        description: t('c87a24eb169b592c995625f5cd3651ef'),
        navigateURL: productAvatarURL,
      },
      // {
      //   pic: (
      //     <Image
      //       src={avatarVideo}
      //       className="w-full h-full"
      //       alt={t('User-survey-a6-2')}
      //     />
      //   ),
      //   title: t('User-survey-a6-2'),
      //   description: t('c87a24eb169b592c995625f5cd3651ef'),
      // },
      // {
      //   pic: (
      //     <Image src={textToSpeech} className="w-full h-full" alt={t('merror.sub.tts')} />
      //   ),
      //   title: t('merror.sub.tts'),
      //   description: t('d808a0222e6a990ec964a37d55e3c1c5'),
      // },
      // {
      //   pic: (
      //     <Image
      //       width={276}
      //       height={122}
      //       src={'/images/3.0-voiceChanger.png'}
      //       className="w-full h-full"
      //       priority
      //       alt={t('AI-Voice-Changing')}
      //     />
      //   ),
      //   title: t('AI-Voice-Changing'),
      //   description: t('AI---2'),
      //   navigateURL: voiceCloneURL + `?tab=${VoiceCloneTabParam.TEXT_TO_SPEECH}`,
      // },
      {
        pic: (
          <Image
            width={276}
            height={122}
            src={'/images/3.0-ai-removal.png'}
            className="w-full h-full"
            priority
            alt={t('bc.removal')}
          />
        ),
        title: t('bc.removal'),
        description: t('7b3381742b545d194e4b204cc40b6846-2'),
        navigateURL: aiRemovalURL,
      },
      {
        pic: (
          <Image
            width={276}
            height={122}
            src={'/images/ai-video-editor.png'}
            className="w-full h-full"
            priority
            alt={t('9613af8a82f375ffce54844fc0a470cc')}
          />
        ),
        title: t('9613af8a82f375ffce54844fc0a470cc'),
        description: t('ecb567ba242317da5f393657977972d7'),
        navigateURL: aiVideoEditURL,
      },
    ],
    [],
  );

  const navigateTo = (url: string, index: number) => {
    if (!url) return;
    trackEvent(EventNewID.RECOMMEND_CLICK, { position_id: index });
    sessionStorage.setItem(ROUTE_FROM, PageVisitFrom.HOME_CLICK);
    navigate(() => {
      router.replace(url);
    });
  };

  return (
    <div className="grid grid-cols-4 gap-[16px] placement-center">
      {tools.map(({ navigateURL, pic, title, description }, index) => (
        <div
          key={index}
          className={styles.toolItem}
          onClick={() => navigateTo(navigateURL, index)}
        >
          <div className=" overflow-hidden">{pic}</div>
          <div className={styles.toolInfo}>
            <span className="font-[500] text-[14px]">{title}</span>
            <span className="text-[12px] text-[#666666]">{description}</span>
          </div>
        </div>
      ))}
    </div>
  );
});

export default PopularTool;
